import React, { useState } from "react";
import { menu } from "../assets/data/menu";
import Button from "./Button";

import { Link, NavLink } from "react-router-dom";
import logo from "../assets/img/logo-blue.svg";
import ConnectWalletPopup from "./ConnectWalletPopup";
import Bar from "./icons/Bar";
import Close from "./icons/Close";
const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [isConnectWalletOpen, setIsConnectWalletOpen] = useState(false);
	const [sticky, setSticky] = useState(false);

	const handleScroll = () => {
		const position = window.pageYOffset;
		if (position < 1) {
			setSticky(false);
		} else {
			setSticky(true);
		}
	};
	window.addEventListener("scroll", handleScroll);
	return (
		<>
			<header className={`${sticky ? "sticky " : ""}`}>
				<div className="container">
					<div className="header-wrapper d-flex justify-content-between align-items-center">
						<Link to="/" className="logo">
							<img src={logo} alt="" />
						</Link>
						<div
							className="header-bar d-lg-none"
							onClick={() => setMenuOpen(!menuOpen)}
						>
							{menuOpen ? <Close /> : <Bar />}
						</div>
						<div className={`menu-area ${menuOpen ? "active" : ""}`}>
							<ul className="menu">
								{menu &&
									menu.map(
										({ text, target, link, tbc, disabled }, i) => (
											<li key={i}>
												{!disabled ? (
													target ? (
														<a
															href={link}
															target={target}
															className={`menu-link ${
																tbc ? "me-lg-4" : ""
															}`}
															onClick={() =>
																setMenuOpen(!menuOpen)
															}
														>
															{text}{" "}
															{tbc && (
																<sup className="tbc">{tbc}</sup>
															)}
														</a>
													) : (
														<NavLink
															to={link}
															className={`menu-link`}
															onClick={() =>
																setMenuOpen(!menuOpen)
															}
														>
															{text}{" "}
															{tbc && (
																<sup className="tbc">{tbc}</sup>
															)}
														</NavLink>
													)
												) : (
													<span
														className={`menu-link ${
															disabled ? "disabled" : ""
														}`}
														onClick={() => setMenuOpen(!menuOpen)}
													>
														{text}{" "}
														{tbc && (
															<sup className="tbc">{tbc}</sup>
														)}
													</span>
												)}
											</li>
										)
									)}
							</ul>
							<div className="login-btns">
								<Button
									text="Connect to a Wallet"
									link="/"
									onClick={() => {
										setMenuOpen(!menuOpen);
										setIsConnectWalletOpen(!isConnectWalletOpen);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</header>
			<ConnectWalletPopup
				popup={isConnectWalletOpen}
				setPopup={setIsConnectWalletOpen}
			/>
		</>
	);
};

export default Header;
